export interface IRestaurantParams {
  sort: string;
  page: number;
  size: number;
  facilityIds?: string;
}
export const getDiningRequestParams = (
  sort: string,
  page: number,
  size: number,
  facilityIds?: string
) => {
  const params = {} as IRestaurantParams;
  if (sort) {
    params['sort'] = sort;
  }
  if (page) {
    params['page'] = page;
  }
  if (size) {
    params['size'] = size;
  }
  if (facilityIds) {
    params['facilityIds'] = facilityIds;
  }
  return params;
};
